import * as React from "react";
const SvgFiRrShop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-shop_svg__a)">
      <path
        fill="#062147"
        d="M24 10a1 1 0 0 0-.024-.217l-1.3-5.868A4.97 4.97 0 0 0 17.792 0H6.208a4.97 4.97 0 0 0-4.88 3.915L.024 9.783A1 1 0 0 0 0 10v1c0 .974.355 1.914 1 2.643V19a5.006 5.006 0 0 0 5 5h12a5.006 5.006 0 0 0 5-5v-5.357c.645-.73 1-1.67 1-2.643zm-22 .11 1.28-5.76A2.98 2.98 0 0 1 6.208 2H7v3a1 1 0 0 0 2 0V2h6v3a1 1 0 0 0 2 0V2h.792a2.98 2.98 0 0 1 2.928 2.35L22 10.11V11a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2 1 1 0 0 0-2 0 2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2 1 1 0 1 0-2 0 2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM18 22H6a3 3 0 0 1-3-3v-4.127c.327.085.663.127 1 .127h1a4 4 0 0 0 3-1.357A4 4 0 0 0 11 15h2a4 4 0 0 0 3-1.357A4 4 0 0 0 19 15h1c.337 0 .673-.042 1-.127V19a3 3 0 0 1-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-shop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrShop;
